var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleepStudyDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0325 10.3891L13.6287 6.79289L15.0429 8.20711L9.03249 14.2175L3.02208 8.20711L4.43629 6.79289L8.03249 10.3891L8.03249 0.782486L10.0325 0.782486V10.3891Z",
    className: "fill-white transition duration-200 ease-out-quad"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.5H2V17.5H16V13.5H18V19.5H0V13.5Z",
    className: "fill-white transition duration-200 ease-out-quad"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStudyDownload);
export default __webpack_public_path__ + "static/media/sleep-study-download.4db56f627333c22f8e44326213f42fbf.svg";
export { ForwardRef as ReactComponent };